/**
 * TrafficRecording
 * 
 * @Author: Focci
 * @Date: 2023-07-18 22:02:59
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-18 22:02:59
 */

// import PropTypes from 'prop-types'
import { ButtonBase } from '@comp/material'
import { filter } from 'lodash-es'
import CloseIcon from '@mui/icons-material/Close'
import { options } from './TrafficType'

export default function TrafficRecording({
  data = [],
  onClick = () => {},
  onClose = () => {}
}) {
  return (
    <div className="mt-6">
      {data.map((item, index) => (
        <div 
          key={`${item.proximity}_${index}`} 
          className="flex items-center justify-between p-2 border border-gray-200 mt-1 bg-gray-50"
        >
          <span 
            role="button"
            aria-label="Button"
            tabIndex="0"
            onClick={() => onClick({ item, index })} 
            onKeyPress={() => onClick({ item, index })} 
            className="cursor-pointer underline pr-2"
          >
            {item.title}
          </span>
          <div className="flex items-center justify-between w-20">
            <span>
              {filter(options, (f) => f.value === item.proximity)[0].icon}
            </span>
            <span className="ml-2 whitespace-nowrap pr-1">{`${item.duration} mins`}</span>
            <ButtonBase onClick={() => onClose({ item, index })}>
              <CloseIcon sx={{ fontSize: '.7rem' }} />
            </ButtonBase>
          </div>
        </div>
      ))}
    </div>
  )
}

// TrafficRecording.propTypes = {
//   className: PropTypes.string,
// }
